/* ═══════════════════════════════════════════════════════════════════════════
   FSS social layer — starring ("My Stars"), "Want in?" gate, personalized rows
   (Based on your recent views / Recently viewed / My Stars / Suggested for you),
   the "You might be into" keyword strip, the 4-then-5 homepage grid, the About
   panel, and cookie consent. Loaded after theme.js; talks to it through
   window.fssShootStar / fssApplyQuery / fssAfterFilter / fssNoteProduct.
   All personal state is localStorage (no server), keyed:
     fss_recent_viewed  [handles]       (written by theme.js on modal open)
     fss_stars          [handles]
     fss_interest       {term: score}
     fss_cookie_consent {analytics, marketing, preferences, ts}
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function lsGet(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function signedIn() { if (typeof VIEW !== 'undefined' && VIEW === 'guest') return false; var u = lsGet('fss_user', null); return !!(u && u.id_token); }
  var STAR_IMG = (window.fss && window.fss.starImageUrl) || '/star_icon.png';
  var STAR_SVG = '<svg class="fss-star-ico" viewBox="0 0 64 64" aria-hidden="true"><defs><filter id="fssRing" x="-25%" y="-25%" width="150%" height="150%" color-interpolation-filters="sRGB"><feMorphology in="SourceAlpha" operator="dilate" radius="2.2" result="d"/><feComposite in="d" in2="SourceAlpha" operator="out" result="ring0"/><feGaussianBlur in="ring0" stdDeviation="0.6" result="ring"/><feFlood flood-color="#fff" flood-opacity="1" result="c"/><feComposite in="c" in2="ring" operator="in"/></filter></defs><image class="fss-star-fillimg" href="' + STAR_IMG + '" x="5" y="5" width="54" height="54" preserveAspectRatio="xMidYMid meet"/><image class="fss-star-ringimg" href="' + STAR_IMG + '" x="5" y="5" width="54" height="54" preserveAspectRatio="xMidYMid meet" filter="url(#fssRing)"/></svg>';
  var SRV = (window.fss && window.fss.paymentServerUrl) || 'https://pay.fivestarsilver.com';
  function userToken() { if (typeof VIEW !== 'undefined' && VIEW === 'guest') return null; var u = lsGet('fss_user', null); return u && u.id_token; }
  function adminToken() { var u = lsGet('fss_user', null); return u && u.id_token; }   /* always the real token (admin actions) */
  var LOGO_IMG = (window.fss && window.fss.logoUrl) || (document.getElementById('logo-img') || {}).src || '';

  var products = [];
  try { products = JSON.parse(($('#fss-product-data') || {}).textContent || '[]'); } catch (e) { products = []; }
  var byHandle = {}; products.forEach(function (p) { byHandle[p.handle] = p; });
  var onHome = !!$('#fss-personal-rows');
  /* admin switches (shop metafield fss.module_config, loaded as window.FSS_MODULE_CONFIG): both OFF unless enabled */
  var MC = window.FSS_MODULE_CONFIG || {};
  var SHOW_RECENT = MC.showRecentViews === true;
  var SHOW_KEYWORDS = MC.showKeywords === true;
  var SHOW_STARS = MC.showStars === true;
  /* Which cart control phones get. 'blue-bar' (the original floating blue CART bar, and the
     default) or 'dark-pill' (the compact bottom pill). Admin-switchable in ⚙ Settings; stored
     in the same fss.module_config metafield as every other site setting. */
  var CART_BAR_STYLE = (MC.cart_bar_style === 'dark-pill') ? 'dark-pill' : 'blue-bar';
  if (MC.descBox === false) document.documentElement.classList.add('fss-no-descbox');   /* admin preview: no description outline */
  if (!SHOW_STARS) document.documentElement.classList.add('fss-no-stars');   /* hides every star button (tiles, rows, modal) */
  var ADMIN_EMAIL = 'theodorepalsercontact@gmail.com';
  function isAdmin() { var u = lsGet('fss_user', null); return !!(u && u.id_token && String(u.email || '').toLowerCase() === ADMIN_EMAIL); }
  /* admin VIEW MODE: 'admin' (default) | 'customer' (signed-in shopper, no admin UI) | 'guest' (logged-out shopper) */
  var VIEW = (lsGet('fss_view_mode', 'admin') || 'admin'); if (!isAdmin()) VIEW = 'admin';
  window.fssAdminActive = function () { return isAdmin() && VIEW === 'admin'; };
  if (isAdmin() && VIEW !== 'admin') {
    document.documentElement.classList.add('fss-view-customer');
    /* block the inline title/description/price editors while previewing */
    document.addEventListener('dblclick', function (e) { if (e.target.closest && e.target.closest('[data-edit]')) e.stopPropagation(); }, true);
  }

  /* ───────── tag → keyword terms ───────── */
  var GENERIC = /^(tshirt|t-shirts?|tee|sale|sale-\d+|new|silver|other|item|\d+(\.\d+)?|size-.*|xs|s|m|l|xl|xxl|2xl)$/i;
  function typeLabel(p) {
    var t = String(p.type || '').trim();
    if (/t-?shirt/i.test(t) || (p.tags || []).some(function (x) { return /^(t-?shirts?|tee)$/i.test(String(x).trim()); })) return 'T-Shirts';
    if (!t) return '';
    return /s$/i.test(t) ? t : t + 's';
  }
  function termsFor(p) {
    var out = [], tl = typeLabel(p);
    if (tl) out.push({ q: tl.replace(/s$/i, ''), label: tl });
    (p.tags || []).forEach(function (tag) {
      var t = String(tag).trim(); if (!t || GENERIC.test(t)) return;
      var label = t.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      if (tl && !/silver|ozt|\.\d{3}|sterling| g$/i.test(t)) label += ' ' + tl;
      else if (/silver|ozt|\.\d{3}|sterling| g$/i.test(t) && !/silver/i.test(t)) label += ' Silver';
      out.push({ q: t, label: label });
    });
    return out;
  }
  var interest = lsGet('fss_interest', {});
  function noteInterest(term, w) {
    if (!term) return;
    var k = String(term).toLowerCase().trim(); if (!k) return;
    interest[k] = (interest[k] || 0) + (w || 1);
    lsSet('fss_interest', interest);
  }
  window.fssNoteInterest = function (t, w) { noteInterest(t, w); if (typeof scheduleSync === 'function') scheduleSync(); };
  window.fssNoteProduct = function (p) {
    termsFor(p).forEach(function (t) { noteInterest(t.q, 1); });
    if (onHome) renderKeywords();
    if (typeof scheduleSync === 'function') scheduleSync();
  };

  /* ───────── "You might be into" strip (homepage, after 4 + 5 + 5 tiles) ───────── */
  function renderKeywords() {
    var strip = $('#fss-kw-strip'), chips = $('#fss-kw-chips'); if (!strip || !chips) return;
    if (!SHOW_KEYWORDS) { strip.hidden = true; return; }
    var freq = {}, label = {};
    products.forEach(function (p) { termsFor(p).forEach(function (t) { var k = t.q.toLowerCase(); freq[k] = (freq[k] || 0) + 1; label[k] = label[k] || t.label; }); });
    var keys = Object.keys(freq).filter(function (k) { return freq[k] >= 1; });
    if (!keys.length) { strip.hidden = true; return; }
    if (window.innerWidth < 768) { strip.hidden = true; return; }   /* desktop only */
    keys.sort(function (a, b) { return ((interest[b] || 0) * 3 + freq[b]) - ((interest[a] || 0) * 3 + freq[a]); });
    chips.innerHTML = keys.slice(0, 12).map(function (k) {
      return '<button type="button" class="fss-kw-chip" data-q="' + esc(k) + '">' + esc(label[k]) + '</button>';
    }).join('');
    strip.hidden = false;
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.fss-kw-chip'); if (!chip) return;
    var q = chip.dataset.q; noteInterest(q, 3);
    try { sessionStorage.setItem('fss_pending_search', q); } catch (er) {}
    window.location.href = '/marketplace';
  });
  /* marketplace: apply a pending keyword search once the search code is wired */
  (function applyPendingSearch() {
    var q; try { q = sessionStorage.getItem('fss_pending_search'); } catch (e) { return; }
    if (!q) return;
    var tries = 0;
    (function go() {
      if (window.fssApplyQuery && $('#product-grid')) { try { sessionStorage.removeItem('fss_pending_search'); } catch (e) {} window.fssApplyQuery(q); }
      else if (++tries < 50) setTimeout(go, 100);
    })();
  })();

  /* ───────── homepage grid: first row 4 wide, then 5 wide; strip after row 3 ───────── */
  function visibleCards(grid) {
    return $$('.fss-product-card', grid).filter(function (c) { return c.style.display !== 'none' && !c.classList.contains('fss-in-recent') && !c.classList.contains('fss-mobile-margin-tile'); });
  }
  window.fssAfterFilter = function () {
    var grid = $('#product-grid'); if (!grid || !onHome) return;
    var cards = visibleCards(grid);
    cards.forEach(function (c, i) { c.classList.toggle('fss-row1', i < 4); c.classList.toggle('fss-first', i === 0); c.classList.toggle('fss-row2', i === 4); });
    var strip = $('#fss-kw-strip');
    if (strip && window.innerWidth < 768) { strip.hidden = true; }   /* desktop only */
    if (strip && !strip.hidden) {
      var anchor = cards[13] || cards[cards.length - 1];
      if (anchor && anchor.parentNode === grid) { if (anchor.nextSibling !== strip) grid.insertBefore(strip, anchor.nextSibling); }
      else grid.appendChild(strip);
    }
  };

  /* ───────── sticky search bar: measure the product grid and sit exactly over it (survives zoom + the
     condensed-margin layout) ───────── */
  function alignSticky() {
    /* The bar is position:sticky (stays in the page flow → no jump, centred in its column). Sticky ends when
       its column ends, so past that point we pin it with position:fixed at the exact same spot, and un-pin
       on the way back up — both switches happen while the bar's natural spot is off-screen, so nothing moves. */
    var bar = $('#search-bar'), cg = $('#content-grid'); if (!bar || !cg) return;
    if (alignSticky._busy) return; alignSticky._busy = true;
    try { alignStickyInner(bar, cg); } finally { alignSticky._busy = false; }
  }
  function alignStickyInner(bar, cg) {
    var ph = $('#fss-search-ph');
    if (!ph) { ph = document.createElement('div'); ph.id = 'fss-search-ph'; bar.parentNode.insertBefore(ph, bar.nextSibling); }
    function unpin() { bar.classList.remove('fss-fixed'); ph.style.display = 'none'; ph.style.height = '0px'; }
    /* Keep one centred sticky element throughout the scroll. The former
       sticky-to-fixed handoff measured a transformed grid and could shift the
       controls sideways at some Safari zoom levels. */
    unpin();
  }
  window.fssAlignSticky = alignSticky;
  window.addEventListener('scroll', alignSticky, { passive: true });
  window.addEventListener('resize', alignSticky);
  new MutationObserver(function (muts) {
    /* react to the observer toggling .sticky on the bar, but never to our own pin/unpin class changes */
    for (var i = 0; i < muts.length; i++) { var t = muts[i].target; if (t.id === 'search-bar' && t.classList.contains('sticky') === (muts[i].oldValue || '').split(' ').indexOf('sticky') !== -1) continue; if (t.id === 'search-bar' || t.id === 'content-grid') { alignSticky(); return; } }
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'], attributeOldValue: true });

  /* star button markup for other renderers (product modal) */
  window.fssStarButtonHtml = function (handle) {
    if (!SHOW_STARS) return '';
    return '<button type="button" class="fss-star-btn fss-star-btn-modal' + (isStarred(handle) ? ' on' : '') + '" data-star="' + esc(handle) + '" aria-label="Star this item">' + STAR_SVG + '</button>';
  };

  /* ───────── stars ───────── */
  var stars = lsGet('fss_stars', []);
  function isStarred(h) { return stars.indexOf(h) !== -1; }
  function paintStars(root) {
    $$('.fss-star-btn', root).forEach(function (b) { b.classList.toggle('on', isStarred(b.dataset.star)); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fss-star-btn'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.dataset.star;
    var r = b.getBoundingClientRect();
    var i = stars.indexOf(h);
    if (i === -1 && window.fssShootStar) window.fssShootStar(r.left + r.width / 2 - 17, r.top + r.height / 2 - 17, 1);   /* only when starring, not un-starring */
    if (!signedIn()) { openWantIn(); }
    if (i === -1) { stars.unshift(h); noteInterest && byHandle[h] && termsFor(byHandle[h]).forEach(function (t) { noteInterest(t.q, 2); }); }
    else stars.splice(i, 1);
    lsSet('fss_stars', stars);
    paintStars(document);
    scheduleSync();
  }, true);

  /* ───────── "Want in?" gate (not signed in) ───────── */
  function qrSvg() {
    /* placeholder QR — deterministic pseudo-random module grid with the 3 finder squares */
    var n = 25, cells = '', seed = 7;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    for (var y = 0; y < n; y++) for (var x = 0; x < n; x++) {
      var finder = (x < 7 && y < 7) || (x >= n - 7 && y < 7) || (x < 7 && y >= n - 7);
      var on;
      if (finder) { var fx = x < 7 ? x : x - (n - 7), fy = y < 7 ? y : y - (n - 7); on = fx === 0 || fy === 0 || fx === 6 || fy === 6 || (fx >= 2 && fx <= 4 && fy >= 2 && fy <= 4); }
      else on = rnd() > 0.55;
      if (on) cells += '<rect x="' + x + '" y="' + y + '" width="1" height="1"/>';
    }
    return '<svg class="fss-qr" viewBox="-1 -1 27 27" shape-rendering="crispEdges" aria-hidden="true"><rect x="-1" y="-1" width="27" height="27" fill="#fff"/><g fill="#111">' + cells + '</g></svg>';
  }
  var wantIn = null;
  function openWantIn() {
    if (!wantIn) {
      wantIn = document.createElement('div');
      wantIn.className = 'fss-wantin-overlay';
      wantIn.innerHTML =
        '<div class="fss-wantin" role="dialog" aria-label="Want in?">' +
          '<button type="button" class="fss-wantin-close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '<div class="fss-wantin-stars">' + new Array(6).join('<img src="' + STAR_IMG + '" alt="">') + '</div>' +
          '<div class="fss-wantin-title">Want in?</div>' +
          '<div class="fss-wantin-sub">Sign up or log in to keep your stars</div>' +
          '<a class="fss-wantin-btn fss-wantin-primary" href="/account?fss_signup=1">Sign up</a>' +
          '<a class="fss-wantin-btn" href="/account">Log in</a>' +
          '<div class="fss-wantin-or"><span>Or</span></div>' +
          qrSvg() +
          '<div class="fss-wantin-app">Get the Five Star Silver app</div><div class="fss-wantin-app-sub">Scan the QR code to download</div>' +
        '</div>';
      document.body.appendChild(wantIn);
      wantIn.addEventListener('click', function (e) { if (e.target === wantIn || e.target.closest('.fss-wantin-close')) closeWantIn(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeWantIn(); });
    }
    wantIn.classList.add('open');
  }
  function closeWantIn() { if (wantIn) wantIn.classList.remove('open'); }
  window.fssOpenWantIn = openWantIn;

  /* ───────── personalized rows (homepage, above the modules) ───────── */
  /* brand line under a tile: the product's vendor (admin-editable via the ⋯ editor); tees default to Los Angeles Apparel */
  function brandOf(p) {
    var v = String(p.vendor || '').trim();
    if (v && !/^five star silver$/i.test(v)) return v;
    return typeLabel(p) === 'T-Shirts' ? 'Los Angeles Apparel' : (v || p.title);
  }
  function tile(p, portrait) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var size = (p.tags || []).map(String).map(function (t) { var m = /^size-(.+)$/i.exec(t); return m ? m[1].toUpperCase() : null; }).filter(Boolean)[0] || '';
    return '<div class="fss-ptile' + (portrait ? ' fss-ptile-portrait' : '') + '">' +
      '<div class="fss-ptile-img" data-action="open-modal" data-handle="' + esc(p.handle) + '" role="button" tabindex="0">' +
        (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        (p.available ? '' : '<span class="fss-ptile-sold">Sold</span>') +
        '<button type="button" class="fss-star-btn' + (isStarred(p.handle) ? ' on' : '') + '" data-star="' + esc(p.handle) + '" aria-label="Star this item">' + STAR_SVG + '</button>' +
      '</div>' +
      '<div class="fss-ptile-meta">' + (size ? '<span class="fss-ptile-size">' + esc(size) + '</span>' : '') +
        '<span class="fss-ptile-price">' + (p.compare_at_price > p.price ? '<s class="fss-price-was">' + money(p.compare_at_price) + '</s> ' : '') + money(p.price) + '</span>' +
        '<span class="fss-ptile-name">' + esc(brandOf(p)) + '</span></div>' +
    '</div>';
  }
  function row(id, title, items, opts) {
    opts = opts || {};
    if (!items.length) return '';
    return '<section class="fss-prow-wrap" id="' + id + '">' +
      '<div class="fss-prow-head"><h2 class="fss-prow-title">' + esc(title) + '</h2>' +
        (opts.seeMoreQ != null ? '<a class="fss-see-more" href="/marketplace" data-see-more="' + esc(opts.seeMoreQ) + '">See more</a>' : '') +
        (opts.clear ? '<button type="button" class="fss-see-more" data-clear="' + opts.clear + '">Clear all</button>' : '') +
      '</div>' +
      '<div class="fss-prow' + (opts.tall ? ' fss-prow-tall' : '') + '">' + items.map(function (p) { return tile(p, true); }).join('') + '</div>' +
    '</section>';
  }
  function related(seedHandles, excludeSet, n) {
    var mine = {}; seedHandles.forEach(function (h) { var p = byHandle[h]; if (p) termsFor(p).forEach(function (t) { mine[t.q.toLowerCase()] = (mine[t.q.toLowerCase()] || 0) + 1; }); });
    Object.keys(interest).forEach(function (k) { mine[k] = (mine[k] || 0) + interest[k] * 0.5; });
    return products.filter(function (p) { return !excludeSet[p.handle] && (p.featured_image || (p.images && p.images[0])); })
      .map(function (p) { var s = 0; termsFor(p).forEach(function (t) { s += mine[t.q.toLowerCase()] || 0; }); return { p: p, s: s + (p.available ? 0.25 : 0) }; })
      .sort(function (a, b) { return b.s - a.s; }).slice(0, n).map(function (x) { return x.p; });
  }
  function renderRows() {
    var host = $('#fss-personal-rows'); if (!host) return;
    var html = '';
    var viewed = lsGet('fss_recent_viewed', []).filter(function (h) { return byHandle[h]; });
    if (SHOW_RECENT && viewed.length) {
      var ex = {}; viewed.forEach(function (h) { ex[h] = 1; });
      var based = related(viewed, ex, 12).filter(function (p) { return p.available; });
      if (based.length < 6) {   /* seen almost everything → top up with related items already viewed (never the latest one) */
        var ex2 = {}; ex2[viewed[0]] = 1; based.forEach(function (p) { ex2[p.handle] = 1; });
        based = based.concat(related(viewed, ex2, 12).filter(function (p) { return p.available && !ex2[p.handle]; }));
      }
      if (based.length >= 6) {
        var topTerm = termsFor(byHandle[viewed[0]])[0];
        html = row('fss-row-based', 'Based on your recent views', based.slice(0, 6), { seeMoreQ: topTerm ? topTerm.q : '' });
      }
    }
    host.innerHTML = html;
    host.hidden = !html;
    placeRows();
  }
  /* mobile: the row sits at the very top (above the colourful modules); desktop: under the search bar */
  var rowsHome = null;
  function placeRows() {
    var host = $('#fss-personal-rows'), mods = $('#fss-modules'); if (!host || !mods) return;
    if (!rowsHome) rowsHome = { parent: host.parentNode, next: host.nextSibling };
    if (window.innerWidth < 768) { if (host.nextSibling !== mods) mods.parentNode.insertBefore(host, mods); }
    else {
      /* desktop: full-width row ABOVE everything (modules + left margin) — first child of the content grid */
      var cg = $('#content-grid');
      if (cg && cg.firstElementChild !== host) cg.insertBefore(host, cg.firstChild);
    }
  }
  window.addEventListener('resize', placeRows);
  document.addEventListener('click', function (e) {
    var sm = e.target.closest('[data-see-more]');
    if (sm) { e.preventDefault(); var q = sm.dataset.seeMore; if (q) { try { sessionStorage.setItem('fss_pending_search', q); } catch (er) {} } window.location.href = '/marketplace'; return; }
    var cl = e.target.closest('[data-clear]');
    if (cl) { lsSet(cl.dataset.clear, []); renderRows(); }
  });
  /* keep "Recently viewed" fresh when a modal opens (theme.js writes the key on open) */
  var lastViewedJson = JSON.stringify(lsGet('fss_recent_viewed', []));
  setInterval(function () { var j = JSON.stringify(lsGet('fss_recent_viewed', [])); if (j !== lastViewedJson) { lastViewedJson = j; scheduleSync(); } }, 1500);

  /* ───────── server sync (signed-in only): stars + recent views + interest follow the account ─────────
     Boot: pull the account copy and merge with this browser (union of stars, newest-first views,
     max of interest), then push the merged result. After that every change is pushed, debounced. */
  var syncTimer = null, syncing = false, dirty = false;
  function post(path, body) {
    return fetch(SRV + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' })
      .then(function (r) { return r.json().then(function (d) { d._status = r.status; return d; }); });
  }
  function snapshot() { return { id_token: userToken(), stars: stars.slice(0, 500), views: lsGet('fss_recent_viewed', []).slice(0, 60), interest: interest }; }
  function scheduleSync() {
    if (!userToken()) return;
    dirty = true;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(pushState, 800);
  }
  function pushState() {
    if (!userToken() || syncing) return;
    syncing = true; dirty = false;
    post('/api/me/state/put', snapshot()).then(function (d) {
      syncing = false;
      if (d && d._status === 401) { return; }   /* token expired → local only until next sign-in */
      if (dirty) scheduleSync();
    }).catch(function () { syncing = false; });
  }
  function pullState() {
    if (!userToken()) return;
    post('/api/me/state/get', { id_token: userToken() }).then(function (d) {
      if (!d || !d.ok) return;
      var merged = false;
      (d.stars || []).forEach(function (h) { if (stars.indexOf(h) === -1) { stars.push(h); merged = true; } });
      var lv = lsGet('fss_recent_viewed', []); var sv = d.views || [];
      var views = lv.concat(sv.filter(function (h) { return lv.indexOf(h) === -1; })).slice(0, 60);
      if (views.length !== lv.length) { lsSet('fss_recent_viewed', views); merged = true; }
      Object.keys(d.interest || {}).forEach(function (k) { var v = Number(d.interest[k]) || 0; if (v > (interest[k] || 0)) { interest[k] = v; merged = true; } });
      lsSet('fss_stars', stars); lsSet('fss_interest', interest);
      paintStars(document);
      if (onHome) { renderKeywords(); renderRows(); window.fssAfterFilter(); }
      pushState();   /* write the merged copy back so every device converges */
    }).catch(function () {});
  }
  var _origNote = noteInterest;

  /* ───────── About panel (drawer → About) ───────── */
  var about = null;
  window.fssOpenAbout = function () {
    if (!about) {
      about = document.createElement('div');
      about.className = 'fss-wantin-overlay fss-about-overlay';
      about.innerHTML = '<div class="fss-wantin fss-about" role="dialog" aria-label="About">' +
        '<button type="button" class="fss-wantin-close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
        (LOGO_IMG ? '<img class="fss-about-logo" src="' + LOGO_IMG + '" alt="Five Star Silver">' : '') +
        '<div class="fss-about-est">EST. FEB 2023 · LOS ANGELES</div>' +
        '<p>Five Star Silver is a small Los Angeles label. We hand-pour solid .999 fine silver rounds, cubes and figures in downtown LA, and print our graphic tees on garment-dyed Los Angeles Apparel blanks.</p>' +
        '<p>Everything is made in small runs — most pieces are 1 of 1. New drops land on the marketplace as they are finished.</p>' +
        '<p><a href="mailto:info@fivestarsilver.com">info@fivestarsilver.com</a></p>' +
        '</div>';
      document.body.appendChild(about);
      about.addEventListener('click', function (e) { if (e.target === about || e.target.closest('.fss-wantin-close')) about.classList.remove('open'); });
    }
    about.classList.add('open');
  };
  /* drawer logo → home, always a fresh load */
  var dl = $('#nav-drawer-logo');
  if (dl) dl.addEventListener('click', function (e) { e.preventDefault(); if (location.pathname === '/') location.reload(); else location.href = '/'; });

  /* ───────── cookies ─────────
     2026-09-23 (operator): the consent UI is GONE — no banner, no bottom-left cookie
     circle, no "Manage preferences" panel, on the website and in the app. We never
     prompt again. Shopify's own Customer Privacy API is still driven, but only from a
     choice a visitor made BEFORE this change (fss_cookie_consent already in
     localStorage); with nothing stored we simply say nothing and let Shopify apply the
     shop's own default, which is what keeps cart/checkout working. */
  (function () {
    var stored = lsGet('fss_cookie_consent', null);
    if (!stored) return;
    try {
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err || !window.Shopify.customerPrivacy) return;
          window.Shopify.customerPrivacy.setTrackingConsent({
            analytics: !!stored.analytics, marketing: !!stored.marketing,
            preferences: !!stored.preferences, sale_of_data: !!stored.marketing
          }, function () {});
        });
      }
    } catch (e) {}
  })();

  /* ───────── MOBILE / iOS CART: optional dark pill ─────────
     OFF by default. The site's phone cart control is the same blue CART bar the desktop
     uses (2026-09-24: the operator did not approve replacing it, so blue-bar is the default
     and the only thing that ships unless it is switched on).

     When an admin picks "Dark pill" in ⚙ Settings → Phone cart bar, this hides the blue bar
     at phone widths and puts a compact pill at the bottom of the screen instead. Tapping it
     opens the same slide-in drawer — literally by clicking #cart-bar-inner, whose listener in
     theme.js IS openCartDrawer(), so there is exactly one drawer-opening code path. The count
     mirrors #cart-bar-count, which theme.js's updateCartUI() already keeps correct. */
  (function () {
    if (CART_BAR_STYLE !== 'dark-pill') return;   /* default 'blue-bar': leave the bar alone */
    var bar = document.getElementById('cart-bar');
    if (!bar) return;

    var css = document.createElement('style');
    css.id = 'fss-bcart-css';
    css.textContent = [
      '@media (max-width: 767px) {',
      '  .fss-cart-bar, #cart-bar { display: none !important; }',
      '  #fss-bcart { display: flex !important; }',
      '  body { padding-bottom: 64px; }',
      '}',
      '#fss-bcart {',
      '  display: none; position: fixed; z-index: 1200;',
      '  left: 50%; transform: translateX(-50%);',
      '  bottom: calc(14px + env(safe-area-inset-bottom, 0px));',
      '  align-items: center; gap: 10px;',
      '  padding: 11px 20px; border: 1px solid var(--border);',
      '  border-radius: var(--radius-full, 9999px);',
      '  background: var(--bg-card); color: var(--text-primary);',
      '  font: 700 13px/1 Inter, system-ui, -apple-system, sans-serif;',
      '  letter-spacing: .08em; text-transform: uppercase;',
      '  box-shadow: 0 6px 22px rgba(0,0,0,.18); cursor: pointer;',
      '  -webkit-tap-highlight-color: transparent;',
      '}',
      '#fss-bcart:active { transform: translateX(-50%) scale(.97); }',
      '#fss-bcart.fss-bcart-hidden { display: none !important; }',
      '#fss-bcart .fss-bcart-svg { width: 18px; height: 18px; flex: 0 0 auto; }',
      '#fss-bcart .fss-bcart-n {',
      '  min-width: 20px; height: 20px; padding: 0 6px; border-radius: 10px;',
      '  background: var(--accent-cart, #2563eb); color: #fff;',
      '  display: inline-flex; align-items: center; justify-content: center;',
      '  font-size: 11px; letter-spacing: 0;',
      '}',
      '#fss-bcart .fss-bcart-total { font-weight: 600; letter-spacing: 0; text-transform: none; }'
    ].join('\n');
    document.head.appendChild(css);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'fss-bcart';
    btn.setAttribute('aria-label', 'Open cart');
    btn.innerHTML =
      '<svg class="fss-bcart-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
      '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
      '<span class="fss-bcart-n" id="fss-bcart-n">0</span>' +
      '<span>Cart</span>' +
      '<span class="fss-bcart-total" id="fss-bcart-total"></span>';
    document.body.appendChild(btn);

    /* Open the drawer through the blue bar's own click handler — same function, one path. */
    btn.addEventListener('click', function () {
      var inner = document.getElementById('cart-bar-inner');
      if (inner) inner.click();
    });

    var srcN = document.getElementById('cart-bar-count');
    var srcT = document.getElementById('cart-bar-total');
    var outN = document.getElementById('fss-bcart-n');
    var outT = document.getElementById('fss-bcart-total');
    function sync() {
      var n = parseInt((srcN && srcN.textContent) || '0', 10) || 0;
      outN.textContent = n;
      outT.textContent = (srcT && n > 0) ? srcT.textContent.trim() : '';
      btn.style.visibility = 'visible';
    }
    if (srcN) {
      new MutationObserver(sync).observe(srcN, { childList: true, characterData: true, subtree: true });
    }
    if (srcT) {
      new MutationObserver(sync).observe(srcT, { childList: true, characterData: true, subtree: true });
    }
    sync();
    /* theme.js fetches /cart.js after load; catch the first paint too. */
    setTimeout(sync, 600); setTimeout(sync, 2000);

    /* While the drawer (or the search/filter overlays that dim the page) is open the
       pill would sit on top of the Checkout button — stand down until it closes. */
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      var hideWhileOpen = function () {
        btn.classList.toggle('fss-bcart-hidden', drawer.classList.contains('open'));
      };
      new MutationObserver(hideWhileOpen).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      hideWhileOpen();
    }
  })();

  /* ───────── MARKETPLACE ONLY: "Advanced" → tile width (tiles per row, phone + desktop), per browser ───────── */
  var TILE_DEFAULTS = { mobile: 2, desktop: 5 };
  function onMarketplace() { return /\/marketplace/.test(location.pathname) || !!$('.fss-main-col-full'); }
  function tileCols() { var v = lsGet('fss_tile_cols', {}) || {}; return { mobile: Math.min(4, Math.max(1, parseInt(v.mobile, 10) || TILE_DEFAULTS.mobile)), desktop: Math.min(8, Math.max(2, parseInt(v.desktop, 10) || TILE_DEFAULTS.desktop)) }; }
  function applyTileCols() {
    if (!onMarketplace()) return;
    var c = tileCols(), n = window.innerWidth < 600 ? c.mobile : c.desktop;
    ['#product-grid', '#product-grid-2col'].forEach(function (sel) { var g = $(sel); if (g) g.style.gridTemplateColumns = 'repeat(' + n + ', minmax(0, 1fr))'; });
  }
  function tileWidthHtml() {
    var c = tileCols();
    function row(key, label, val, def) {
      return '<div class="fss-tw-row"><span class="fss-tw-label">' + label + ' <small>default ' + def + '</small></span>' +
        '<span class="fss-tw-ctl"><button type="button" class="fss-tw-btn" data-tw="' + key + '" data-d="-1" aria-label="Fewer per row">−</button>' +
        '<b class="fss-tw-val" data-tw-val="' + key + '">' + val + '</b>' +
        '<button type="button" class="fss-tw-btn" data-tw="' + key + '" data-d="1" aria-label="More per row">+</button></span></div>';
    }
    return '<div class="fss-adv-panel" hidden><div class="fss-tw-title">Tile width <small>tiles per row</small></div>' +
      row('mobile', 'Phone', c.mobile, TILE_DEFAULTS.mobile) + row('desktop', 'Laptop / desktop', c.desktop, TILE_DEFAULTS.desktop) +
      '<button type="button" class="fss-tw-reset" data-tw-reset>Reset to default</button></div>';
  }
  function mountAdvanced(host, before) {
    if (!host || host.querySelector('.fss-adv-link')) return;
    var wrap = document.createElement('div'); wrap.className = 'fss-adv-wrap';
    wrap.innerHTML = '<button type="button" class="fss-adv-link">Advanced</button>' + tileWidthHtml();
    if (before && before.parentNode === host) host.insertBefore(wrap, before.nextSibling); else host.appendChild(wrap);
  }
  function refreshTileVals() { var c = tileCols(); $$('[data-tw-val]').forEach(function (b) { b.textContent = c[b.dataset.twVal]; }); }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.fss-adv-link');
    if (link) { e.preventDefault(); e.stopPropagation(); var p = link.parentNode.querySelector('.fss-adv-panel'); p.hidden = !p.hidden; link.classList.toggle('open', !p.hidden); return; }
    var btn = e.target.closest('[data-tw]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var c = tileCols(); var k = btn.dataset.tw; c[k] = c[k] + parseInt(btn.dataset.d, 10);
      c.mobile = Math.min(4, Math.max(1, c.mobile)); c.desktop = Math.min(8, Math.max(2, c.desktop));
      lsSet('fss_tile_cols', c); refreshTileVals(); applyTileCols(); return;
    }
    if (e.target.closest('[data-tw-reset]')) { e.preventDefault(); e.stopPropagation(); lsSet('fss_tile_cols', {}); refreshTileVals(); applyTileCols(); }
  }, true);
  function initTileWidth() {
    if (!onMarketplace()) return;
    var clear = $('#fss-price-clear'); if (clear) mountAdvanced(clear.parentNode, clear);          /* desktop filter panel */
    var sheet = $('.fss-nav-sheet-price'); if (sheet) mountAdvanced(sheet, null);                  /* mobile filter sheet */
    applyTileCols();
    window.addEventListener('resize', applyTileCols);
  }

  /* ───────── admin: view-as switcher in the profile menu + exit pill ───────── */
  function viewSwitcher() {
    if (!isAdmin()) return;
    var menu = $('#starup-menu'); if (!menu) return;
    var modes = [['admin', 'Admin view'], ['customer', 'Customer view'], ['guest', 'Logged-out view']];
    var wrap = document.createElement('div'); wrap.className = 'fss-view-modes';
    wrap.innerHTML = '<div class="fss-view-modes-title">View site as</div>' + modes.map(function (m) {
      return '<a href="#" class="fss-starup-blob fss-view-blob' + (VIEW === m[0] ? ' on' : '') + '" data-view="' + m[0] + '"><span class="fss-view-dot"></span><span>' + m[1] + '</span></a>';
    }).join('');
    menu.appendChild(wrap);
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-view]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      lsSet('fss_view_mode', b.dataset.view); location.reload();
    }, true);
    if (VIEW !== 'admin') {
      var pill = document.createElement('button'); pill.type = 'button'; pill.className = 'fss-view-pill';
      pill.innerHTML = (VIEW === 'guest' ? 'Logged-out view' : 'Customer view') + ' <b>· exit</b>';
      pill.addEventListener('click', function () { lsSet('fss_view_mode', 'admin'); location.reload(); });
      document.body.appendChild(pill);
    }
  }

  /* ───────── admin: tag editing in the open product (double-click a pill; "+" adds) ───────── */
  var byId = {}; products.forEach(function (p) { byId[String(p.id)] = p; });
  function modalPid() { var t = $('.fss-modal-title[data-pid]'); return t ? t.dataset.pid : null; }
  function saveTags(pid, tags, then) {
    return post('/api/admin/product-edit', { id_token: adminToken(), id: pid, tags: tags.join(', ') })
      .then(function (d) { if (!d || !d.ok) throw new Error((d && (d.error || (d.d && d.d.error))) || 'failed'); if (then) then(); else location.reload(); });
  }
  function tagEditStart(pill) {
    if (pill.querySelector('input')) return;
    var raw = pill.dataset.rawtag, pid = modalPid(); if (!pid) return;
    var inp = document.createElement('input'); inp.type = 'text'; inp.value = raw; inp.className = 'fss-tag-edit';
    var orig = pill.innerHTML; pill.innerHTML = ''; pill.appendChild(inp); inp.focus(); inp.select();
    function finish(commit) {
      if (!commit) { pill.innerHTML = orig; return; }
      var val = inp.value.trim(); var p = byId[pid]; var tags = (p ? p.tags : []).map(String);
      var i = tags.findIndex(function (t) { return t.toLowerCase().trim() === String(raw).toLowerCase().trim(); });
      if (val === '') { if (i !== -1) tags.splice(i, 1); }           /* empty = remove the tag */
      else if (i !== -1) tags[i] = val; else tags.push(val);
      pill.textContent = val || '…'; pill.style.opacity = '0.5';
      saveTags(pid, tags).catch(function (err) { pill.innerHTML = orig; pill.style.opacity = ''; alert('Tag save failed: ' + err.message); });
    }
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); finish(true); } if (e.key === 'Escape') finish(false); });
    inp.addEventListener('blur', function () { setTimeout(function () { if (pill.contains(inp)) finish(false); }, 150); });
  }
  var tagDlg = null;
  function openTagDialog(pid) {
    var all = {}; products.forEach(function (p) { (p.tags || []).forEach(function (t) { var k = String(t).trim(); if (k && !/^(\d+(\.\d+)?|[a-z]{1,3}|xxl|2xl|size-.*)$/i.test(k)) all[k.toLowerCase()] = k; }); });
    var presets = Object.keys(all).sort().map(function (k) { return all[k]; });
    var colors = (window.FSS_MODULE_CONFIG && window.FSS_MODULE_CONFIG.tagColors) || {};
    if (tagDlg) tagDlg.remove();
    tagDlg = document.createElement('div'); tagDlg.className = 'fss-wantin-overlay fss-tagdlg-overlay open';
    tagDlg.innerHTML = '<div class="fss-wantin fss-tagdlg" role="dialog" aria-label="Add tag">' +
      '<button type="button" class="fss-wantin-close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
      '<h3>Add a tag</h3>' +
      '<div class="fss-tagdlg-label">Presets <small>(every tag already used on the site)</small></div>' +
      '<div class="fss-tagdlg-presets">' + presets.map(function (t) { return '<button type="button" class="fss-tagdlg-chip" data-preset="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>' +
      '<div class="fss-tagdlg-label">Or type a new one</div>' +
      '<input type="text" class="fss-tagdlg-input" placeholder="e.g. Limited">' +
      '<div class="fss-tagdlg-label">Colour</div>' +
      '<div class="fss-tagdlg-colors">' +
        ['grey', 'silver', 'orange', 'blue'].map(function (c, i) { return '<label class="fss-tagdlg-color"><input type="radio" name="fss-tagcolor" value="' + c + '"' + (i === 0 ? ' checked' : '') + '><span class="fss-modal-tag fss-tagdlg-swatch-' + c + '">' + c.charAt(0).toUpperCase() + c.slice(1) + '</span></label>'; }).join('') +
      '</div>' +
      '<button type="button" class="fss-wantin-btn fss-wantin-primary fss-tagdlg-add">Add tag</button>' +
      '<div class="fss-adm-settings-msg fss-tagdlg-msg"></div></div>';
    document.body.appendChild(tagDlg);
    var input = tagDlg.querySelector('.fss-tagdlg-input'), msg = tagDlg.querySelector('.fss-tagdlg-msg');
    tagDlg.addEventListener('click', function (e) {
      if (e.target === tagDlg || e.target.closest('.fss-wantin-close')) { tagDlg.remove(); tagDlg = null; return; }
      var chip = e.target.closest('[data-preset]');
      if (chip) { input.value = chip.dataset.preset; var pc = colors[chip.dataset.preset.toLowerCase()]; if (pc) { var r = tagDlg.querySelector('input[value="' + pc + '"]'); if (r) r.checked = true; } return; }
      if (e.target.closest('.fss-tagdlg-add')) {
        var val = input.value.trim(); if (!val) { input.focus(); return; }
        var color = (tagDlg.querySelector('input[name=fss-tagcolor]:checked') || {}).value || 'grey';
        var p = byId[pid]; var tags = (p ? p.tags : []).map(String);
        if (!tags.some(function (t) { return t.toLowerCase().trim() === val.toLowerCase(); })) tags.push(val);
        msg.textContent = 'Saving…';
        var chain = Promise.resolve();
        if (color !== 'grey' || colors[val.toLowerCase()]) {
          chain = fetch(SRV + '/api/admin/module-config').then(function (r) { return r.json(); }).then(function (cfg) {
            cfg = cfg || {}; cfg.tagColors = cfg.tagColors || {};
            if (color === 'grey') delete cfg.tagColors[val.toLowerCase()]; else cfg.tagColors[val.toLowerCase()] = color;
            return post('/api/admin/module-config', { id_token: adminToken(), config: cfg });
          });
        }
        chain.then(function () { return saveTags(pid, tags); }).catch(function (err) { msg.textContent = 'Error: ' + err.message; });
      }
    });
    input.focus();
  }
  document.addEventListener('dblclick', function (e) {
    if (!window.fssAdminActive()) return;
    var pill = e.target.closest('.fss-modal-tag[data-rawtag]'); if (!pill) return;
    e.preventDefault(); e.stopPropagation(); tagEditStart(pill);
  }, true);
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.fss-tag-add'); if (!add) return;
    e.preventDefault(); e.stopPropagation();
    if (window.fssAdminActive()) openTagDialog(add.dataset.pid || modalPid());
  }, true);

  /* ───────── admin settings (bottom-left, above Drafts) ───────── */
  function adminSettings() {
    if (!window.fssAdminActive()) return;
    var fab = document.createElement('button'); fab.type = 'button'; fab.className = 'fss-adm-settings-fab'; fab.textContent = '⚙ Settings';
    var panel = document.createElement('div'); panel.className = 'fss-adm-settings'; panel.hidden = true;
    function toggleRow(key, label, sub, on) {
      return '<label class="fss-ck-row"><span><b>' + label + '</b><small>' + sub + '</small></span><input type="checkbox" data-set="' + key + '"' + (on ? ' checked' : '') + '></label>';
    }
    /* Same row, same save path, but for settings that are a choice rather than on/off. */
    function selectRow(key, label, sub, opts, cur) {
      return '<label class="fss-ck-row"><span><b>' + label + '</b><small>' + sub + '</small></span>' +
        '<select data-set="' + key + '" data-kind="value" data-was="' + cur + '">' +
        opts.map(function (o) {
          return '<option value="' + o[0] + '"' + (o[0] === cur ? ' selected' : '') + '>' + esc(o[1]) + '</option>';
        }).join('') + '</select></label>';
    }
    panel.innerHTML = '<h3>Site settings</h3>' +
      toggleRow('showRecentViews', 'Based on your recent views', 'Personalised row at the top of the home page.', SHOW_RECENT) +
      toggleRow('showKeywords', 'You might be into', 'Keyword chips after the third marketplace row (desktop).', SHOW_KEYWORDS) +
      toggleRow('descBox', 'Description outline', 'The thin box around the description in the open product view.', MC.descBox !== false) +
      selectRow('cart_bar_style', 'Phone cart bar', 'Which cart control shows on phone widths. Desktop always uses the blue bar.',
        [['blue-bar', 'Blue bar (default)'], ['dark-pill', 'Dark pill']], CART_BAR_STYLE) +
      '<div class="fss-admin-tag-title">Drag a tag onto a product</div>' +
      '<div class="fss-admin-tag-palette">' +
        ['6.5 oz', '8.5 oz', 'Mineral Wash', 'Los Angeles Apparel'].map(function (tag) {
          return '<button type="button" draggable="true" class="fss-admin-drag-tag" data-drag-tag="' + esc(tag) + '">' + esc(tag) + '</button>';
        }).join('') +
      '</div>' +
      '<div class="fss-adm-settings-msg" id="fss-adm-settings-msg"></div>';
    document.body.appendChild(fab); document.body.appendChild(panel);
    fab.addEventListener('click', function () { panel.hidden = !panel.hidden; });
    document.addEventListener('click', function (e) { if (!panel.hidden && !panel.contains(e.target) && e.target !== fab) panel.hidden = true; });
    panel.addEventListener('change', function (e) {
      var t = e.target.closest('[data-set]'); if (!t) return;
      var msg = $('#fss-adm-settings-msg'); msg.textContent = 'Saving…';
      var tok = userToken();
      /* Checkboxes save a boolean; data-kind="value" rows (the selects) save their string. */
      var isValue = t.dataset.kind === 'value';
      var was = isValue ? t.getAttribute('data-was') : null;
      var next = isValue ? t.value : t.checked;
      fetch(SRV + '/api/admin/module-config').then(function (r) { return r.json(); }).then(function (cfg) {
        cfg = cfg || {}; cfg[t.dataset.set] = next;
        return post('/api/admin/module-config', { id_token: tok, config: cfg });
      }).then(function (d) {
        if (!d || !d.ok) throw new Error((d && d.error) || 'failed');
        if (isValue) t.setAttribute('data-was', t.value);
        msg.textContent = 'Saved ✓ reloading…'; setTimeout(function () { location.reload(); }, 600);
      }).catch(function (err) {
        msg.textContent = 'Error: ' + err.message;
        if (isValue) { if (was !== null) t.value = was; } else { t.checked = !t.checked; }
      });
    });
    panel.addEventListener('dragstart', function (e) {
      var chip = e.target.closest('[data-drag-tag]'); if (!chip) return;
      e.dataTransfer.effectAllowed = 'copy';
      e.dataTransfer.setData('text/fss-tag', chip.dataset.dragTag);
      e.dataTransfer.setData('text/plain', chip.dataset.dragTag);
    });
    document.addEventListener('dragover', function (e) {
      var card = e.target.closest('.fss-product-card, .fss-margin-card, .fss-recent-item');
      if (!card || !card.dataset.productId) return;
      e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; card.classList.add('fss-admin-tag-target');
    });
    document.addEventListener('dragleave', function (e) {
      var card = e.target.closest('.fss-admin-tag-target');
      if (card && !card.contains(e.relatedTarget)) card.classList.remove('fss-admin-tag-target');
    });
    document.addEventListener('drop', function (e) {
      var card = e.target.closest('.fss-product-card, .fss-margin-card, .fss-recent-item');
      document.querySelectorAll('.fss-admin-tag-target').forEach(function (c) { c.classList.remove('fss-admin-tag-target'); });
      if (!card || !card.dataset.productId) return;
      var tag = e.dataTransfer.getData('text/fss-tag'); if (!tag) return;
      e.preventDefault();
      var pid = String(card.dataset.productId), product = byId[pid];
      var tags = (product && product.tags ? product.tags : []).map(String);
      if (!tags.some(function (t) { return t.toLowerCase().trim() === tag.toLowerCase(); })) tags.push(tag);
      var msg = $('#fss-adm-settings-msg'); if (msg) msg.textContent = 'Adding “' + tag + '”…';
      saveTags(pid, tags, function () {
        if (product) product.tags = tags;
        if (msg) msg.textContent = 'Tag added ✓';
      }).catch(function (err) { if (msg) msg.textContent = 'Tag error: ' + err.message; });
    });
  }

  /* ───────── Filters / Fabric tool bubble: when its category is active, park the button above the
     product tiles (right-aligned, on the Marketplace heading line) instead of at the far end of the
     scrolling bubble row; the panel follows so it opens right above the tiles ───────── */
  function relocateTools() {
    var bubbles = $('#tag-bubbles'); if (!bubbles) return;
    var parent = bubbles.getAttribute('data-sub-parent');
    var slot = $('#fss-tool-slot');
    if (!slot) {
      var header = $('.fss-marketplace-header');
      slot = document.createElement('div'); slot.id = 'fss-tool-slot'; slot.className = 'fss-tool-slot';
      if (header) header.appendChild(slot);
      else { var grid = $('#product-grid'); if (!grid) return; var row = document.createElement('div'); row.className = 'fss-tool-slot-row'; row.appendChild(slot); grid.parentNode.insertBefore(row, grid); }
    }
    var panel = $('.fss-tool-panel');
    /* put everything back first */
    $$('.fss-bubble-tool[data-home]').forEach(function (b) { var ph = document.getElementById(b.dataset.home); if (ph) { ph.parentNode.insertBefore(b, ph); ph.remove(); } delete b.dataset.home; });
    if (panel && panel.dataset.home) { var pph = document.getElementById(panel.dataset.home); if (pph) { pph.parentNode.insertBefore(panel, pph); pph.remove(); } delete panel.dataset.home; }
    slot.classList.remove('on');
    /* Keep the active filter inside the bubble row. Moving it to the
       marketplace heading created the detached, floating-right control. */
    return;
  }
  (function () {
    var b = $('#tag-bubbles'); if (!b) return;
    new MutationObserver(relocateTools).observe(b, { attributes: true, attributeFilter: ['data-sub-parent'] });
    relocateTools();
  })();

  /* Category chips stay on one row. The arrow scrolls only the chips; the
     filter control remains pinned at the right edge. */
  (function () {
    var strip = $('#tag-bubbles');
    if (!strip || !strip.parentNode || $('.fss-bubbles-next')) return;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'fss-bubbles-next'; next.setAttribute('aria-label', 'More categories');
    next.innerHTML = '&#8250;';
    strip.parentNode.insertBefore(next, strip.nextSibling);
    function sync() {
      var overflow = strip.scrollWidth > strip.clientWidth + 4;
      next.classList.toggle('on', overflow);
      next.style.opacity = overflow && strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 4 ? '.45' : '1';
    }
    next.addEventListener('click', function () {
      if (strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 4) strip.scrollTo({ left: 0, behavior: 'smooth' });
      else strip.scrollBy({ left: Math.max(180, strip.clientWidth * .55), behavior: 'smooth' });
      setTimeout(sync, 350);
    });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    new MutationObserver(sync).observe(strip, { childList: true, subtree: true });
    setTimeout(sync, 0);
  })();

  /* drawer: real silver cutouts as the icons; on phones the search-bar hamburger becomes a back arrow on /marketplace */
  (function () {
    var SC = window.FSS_SILVER_CUTOUTS || {};
    $$('.fss-nav-silver').forEach(function (b) {
      var cat = (b.dataset.nav || '').split('>')[1];
      var pool = (SC[cat] && SC[cat].length) ? SC[cat] : (SC.all || []);
      if (!pool.length) return;
      var img = document.createElement('img'); img.className = 'fss-nav-cut'; img.src = pool[0]; img.alt = '';
      var svg = b.querySelector('svg'); if (svg) svg.replaceWith(img); else b.insertBefore(img, b.firstChild);
    });
    if (onMarketplace() && window.innerWidth < 600) {
      var trig = $('#search-nav-trigger');
      if (trig) {
        trig.classList.add('fss-back-mode');
        trig.insertAdjacentHTML('beforeend', '<svg class="fss-menu-back" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>');
        trig.setAttribute('aria-label', 'Back to home');
        trig.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); location.href = '/'; }, true);
      }
    }
  })();

  /* drawer silver links: open the marketplace with that sub-category selected */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fss-nav-silver[data-nav]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    try { sessionStorage.setItem('fss_pending_tag', b.dataset.nav); } catch (er) {}
    location.href = '/marketplace';
  }, true);

  /* ───────── boot ───────── */
  function boot() {
    viewSwitcher();
    adminSettings();
    initTileWidth();
    paintStars(document);
    if (onHome) { renderKeywords(); renderRows(); window.fssAfterFilter(); }
    pullState();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('resize', function () { if (window.fssAfterFilter) window.fssAfterFilter(); });
})();
